var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "naturalvert-llc.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": 1128334262306,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "MTAyMDc3"
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Save your friends Money & Earn",
            "refer_background_color": "#d61de8",
            "refer_text_color": "#ffffff",
            "web_position": "left-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Send a Friend or loved one 10% discount, and earn 10%",
            "popup_description": "Send your friends a 10% discount off their purchase. Once they make a purchase, you\u2019ll earn 10% for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 10% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}